module.exports = __webpack_public_path__ + "static/media/speaker2021.2aadff9b.png";